/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShadowSubsystemAction } from './ShadowSubsystemAction';
import {
    ShadowSubsystemActionFromJSON,
    ShadowSubsystemActionFromJSONTyped,
    ShadowSubsystemActionToJSON,
} from './ShadowSubsystemAction';

/**
 * 
 * @export
 * @interface ShadowAdmissionNextSteps
 */
export interface ShadowAdmissionNextSteps {
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowAdmissionNextSteps
     */
    blocking_subsystems: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowAdmissionNextSteps
     */
    missing_information: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShadowAdmissionNextSteps
     */
    follow_up_items: Array<string>;
    /**
     * 
     * @type {Array<ShadowSubsystemAction>}
     * @memberof ShadowAdmissionNextSteps
     */
    actions: Array<ShadowSubsystemAction>;
}

/**
 * Check if a given object implements the ShadowAdmissionNextSteps interface.
 */
export function instanceOfShadowAdmissionNextSteps(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "blocking_subsystems" in value;
    isInstance = isInstance && "missing_information" in value;
    isInstance = isInstance && "follow_up_items" in value;
    isInstance = isInstance && "actions" in value;

    return isInstance;
}

export function ShadowAdmissionNextStepsFromJSON(json: any): ShadowAdmissionNextSteps {
    return ShadowAdmissionNextStepsFromJSONTyped(json, false);
}

export function ShadowAdmissionNextStepsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowAdmissionNextSteps {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'blocking_subsystems': json['blocking_subsystems'],
        'missing_information': json['missing_information'],
        'follow_up_items': json['follow_up_items'],
        'actions': ((json['actions'] as Array<any>).map(ShadowSubsystemActionFromJSON)),
    };
}

export function ShadowAdmissionNextStepsToJSON(value?: ShadowAdmissionNextSteps | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'blocking_subsystems': value.blocking_subsystems,
        'missing_information': value.missing_information,
        'follow_up_items': value.follow_up_items,
        'actions': ((value.actions as Array<any>).map(ShadowSubsystemActionToJSON)),
    };
}

